import comp from "./PostFeed";
export default comp;
